import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { cubeYearsQueryKeys } from "./queryKeys";

/**
 * Fetches available fiscal years for a cube from the shared endpoint.
 *
 * - `cubeId: string` — returns source years filtered to the cube's range.
 * - `cubeId: null` — returns all calendar years (for target dropdowns).
 * - `cubeId: undefined` — query is disabled (no request made).
 */
export function useFetchCubeYears(cubeId: string | null | undefined) {
  const apiClient = useApi();

  return useQuery({
    queryKey: cubeYearsQueryKeys.byId(cubeId ?? "__all__"),
    staleTime: Infinity,
    enabled: cubeId !== undefined,
    meta: {
      errorMessage: "Failed to fetch cube years"
    },
    queryFn: async () => {
      const response = await apiClient.POST("/v2/forecast/cubes/years", {
        body: { cube_id: cubeId } as { cube_id: string }
      });
      return (
        response.data?.result ?? {
          years: [],
          current_financial_year: null
        }
      );
    }
  });
}
